import { render, staticRenderFns } from "./LegalDocumentSearch.vue?vue&type=template&id=97ec0d32&scoped=true&"
import script from "./LegalDocumentSearch.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentSearch.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentSearch.vue?vue&type=style&index=0&id=97ec0d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ec0d32",
  null
  
)

export default component.exports